import { BlackListInfo } from '../../models/black-list/black-list-info';

/**
 * ブラックリスト入り判定リクエスト
 */
export class CheckBlackListRequest {
	public blackListInfo: BlackListInfo = null; // ブラックリスト判定対象情報
}